import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type { AvailablePhoneNumbersDto, CompanyPhoneNumberStatusDto } from '~/swagger/portal/Api';

export const BASE_URL = '/api/phones';
class PhonesRepository extends BaseRestRepository {
  public async canCompanySendTextMessages(): Promise<CompanyPhoneNumberStatusDto> {
    const response = await this.fetchWithAuth(BASE_URL + '/status');
    return this.getJsonResponse(response);
  }
  public async getAvailablePhoneNumbers(query: string): Promise<AvailablePhoneNumbersDto> {
    const response = await this.fetchWithAuth(urlWithQuery(BASE_URL + '/available', { startsWith: query }), {}, false);
    return this.getJsonResponse(response);
  }

  public async updateCompanyPhoneNumber(phoneNumber: string): Promise<unknown> {
    const response = await this.fetchWithAuth(BASE_URL + '/current', {
      method: 'PUT',
      body: JSON.stringify({ phoneNumber }),
    });
    return this.getJsonResponse(response);
  }
}

export const phonesRepository = new PhonesRepository();
